import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Ticket } from 'src/app/models';
import { TcDataService } from 'src/app/shared/services';

@Component({
  selector: 'app-abstract-ticket',
  template: ``,
  styles: [],
  standalone: false,
})
export abstract class AbstractTicketComponent implements OnInit, OnDestroy {
  entity?: Ticket;
  saving = false;
  saved = false;
  subscriptions: Subscription[] = [];

  constructor(
    protected dataService: TcDataService,
    protected _location: Location,
    protected router: Router
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.dataService.assembleTicketEmitter!!.subscribe(response => this.assembleTicket(response))
    );
  }

  protected updateTicket(newMessage, hasError, skipSave) {
    console.log("this is an abstract function and should be implemented by it's sub components");
  }

  goBack() {
    if (window.history.length > 1) {
      this._location.back();
    } else {
      this.router.navigate(['/']);
    }
  }

  abstract assembleTicket(response: Ticket);

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }
}
